import React from 'react';

const NoteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_24953_12978)">
        <path
          d="M8 10.6667V8M8 6H8.00667M14.6667 8C14.6667 11.5 11.5 14.6667 8 14.6667C4.5 14.6667 1.33333 11.5 1.33333 8C1.33333 4.5 4.5 1.33333 8 1.33333C11.5 1.33333 14.6667 4.5 14.6667 8Z"
          stroke="#43A047"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24953_12978">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteIcon;
